// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__144N4","cell":"ColumnAccessor_cell__eL4l3","firstCellAccent":"ColumnAccessor_firstCellAccent__1KWy7"};